import "./seoCotizador.css";

interface Props {
    titulo?: string;
    texto: string;
}

export const QueCubreEsteSeguro = ({ titulo = "Qué cubre este seguro", texto }: Props) => {
    return (
        <div className="seo-cotizador-section">
            <div className="container">
                <h2 className="seo-cotizador-h2">
                    {titulo}
                </h2>
                <p className="seo-cotizador-texto-bloque">
                    {texto}
                </p>
            </div>
        </div>
    );
};
